import { useLazyQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useCallback } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

type GetCardFunction = (id?: string) => Promise<API.CardFragment | undefined>;

export function useGetCardLazyQuery(): GetCardFunction {
  const [getCard] = useLazyQuery<API.CardDetailsQuery, API.CardDetailsQueryVariables>(
    Queries.card.details,
  );
  return useCallback(
    async (id?: string) => {
      if (isNil(id)) {
        return undefined;
      }
      const result = await getCard({ variables: { id } });
      return result.data?.card ?? undefined;
    },
    [getCard],
  );
}
